import React from 'react';
import { Container, Image } from 'react-bootstrap';
import styles from './index.module.css';
import PresentIcon from '../../images/present_icon.svg';
import WorkshopIcon from '../../images/workshop_icon.svg';
import ConnectIcon from '../../images/connect_icon.svg';
import EventPrice from '../../images/event_price.svg';
import InfoMegaphone from '../../images/mobile/info_megaphone_mobile.svg';

const MoreInfo = () => (
  <Container fluid="xl" className={`${styles.more_info_container}`}>
    <Image src={InfoMegaphone} className={`${styles.info_megaphone}`} />
    <div className={`${styles.more_info_all}`}>
      <div className={`${styles.info_col}`}>
        <Image src={PresentIcon} className={`${styles.present_img}`} />
        <p>Presentations by experts covering all parts of the autism journey</p>
      </div>
      <div className={`${styles.border}`} />
      <div className={`${styles.info_col}  ${styles.info_col_middle}`}>
        <Image src={WorkshopIcon} className={`${styles.workshop_img}`} />
        <p>Interactive workshops</p>
      </div>
      <div className={`${styles.border}`} />
      <div className={`${styles.info_col}`}>
        <Image src={ConnectIcon} className={`${styles.connect_img}`} />
        <p>Connect with families going through the autism journey</p>
      </div>
    </div>
    <Image fluid src={EventPrice} className={`${styles.price_info}`} />
  </Container>
);

export default MoreInfo;
